import { IGameState } from "State/Game/IGameState";
import { ProgressStateHelper } from "State/Player/Progress/ProgressStateHelper";
import { track, TrackMethod } from "Utility/Tracking/Track";
import LevelStateHelper from "../LevelStateHelper";
import { LevelStatus } from "../LevelStatus";

export function levelIntro(state: IGameState): IGameState {
    if (state.levelState.status !== LevelStatus.LOADED) return state;

    state = {
        ...state,
        levelState: {
            ...state.levelState,
            status: LevelStatus.INTRO,
        },
    };
    track('mPlus5Used', 0, TrackMethod.SET);
    track('mMassRemoveUsed', 0, TrackMethod.SET);
    track('mRemoveOneUsed', 0, TrackMethod.SET);
    track('mChangerUsed', 0, TrackMethod.SET);
    track('mJokerUsed', 0, TrackMethod.SET);
    track('mUndoUsed', 0, TrackMethod.SET);
    track('mCoinsSpent', 0, TrackMethod.SET);
    track('mExtraCardsBought', 0, TrackMethod.SET);
    track('mExtraCardsWon', 0, TrackMethod.SET);
    track('mJokerCardsWon', 0, TrackMethod.SET);
    track('mStreakNum', 0, TrackMethod.SET);
    track('mStreakColorNum', 0, TrackMethod.SET);
    track('mHighestPlayStreak', 0, TrackMethod.SET);
    track('mNumBoostersUsedLossAversion', 0, TrackMethod.SET);
    track('mMovesMade', 0, TrackMethod.SET);
    track('mLossAversionCoinsSpent', 0, TrackMethod.SET);
    track('mCoinsBoughtWithAds', 0, TrackMethod.SET);

    const level = ProgressStateHelper.getLevelData(
        state,
        state.levelState.levelNumber,
        state.levelState.levelType
    );
    const hasWonLevel = Boolean(level?.stars);
    track('mIsSuccessRetry', Number(hasWonLevel), TrackMethod.SET);

    const starsToGain = Math.max(3 - (level?.stars ?? 0), 0);
    track('mChestStarsToGain', starsToGain, TrackMethod.SET);

    //Check which FTUX needs to be executed
    state = LevelStateHelper.queueFTUXTasksIfNeeded(state);
    return state;
}